import { IconCreditCard } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { Item } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { messages } from './messages'

import { NoPermissionView } from '../shared/NoPermissionView'
import { useConditions } from '../useConditions'
import { PaymentMethodsEditor } from './Editor'
import { PaymentMethodsView } from './View'
import { usePaymentMethodsOptions } from './usePaymentMethodsOptions'

type PaymentMethodsProps = {
  name: string
}

export function PaymentMethods(props: PaymentMethodsProps) {
  const { name } = props
  const drawerState = useDrawerState()
  const { formatMessage: i18n } = useIntl()
  const { form } = useFormStateContext()

  useConditions({
    name,
    onEdit: drawerState.show,
    label: i18n(messages.title),
    icon: <IconCreditCard />,
  })

  const paymentMethods: Item[] | undefined = useWatch({ form, name })

  const { options, loading, hasPermissionError } = usePaymentMethodsOptions({
    name,
  })

  const handleRemove = () => form.setValue(name, undefined)

  return (
    <>
      <PaymentMethodsView
        values={paymentMethods}
        onEdit={drawerState.show}
        onRemove={handleRemove}
      />
      {hasPermissionError ? (
        <NoPermissionView
          drawerState={drawerState}
          description={messages.unauthorized.description}
          title={messages.title}
        />
      ) : (
        <PaymentMethodsEditor
          name={name}
          state={drawerState}
          options={options}
          loading={loading}
        />
      )}
    </>
  )
}
